// extracted by mini-css-extract-plugin
export var pillWrapper = "_y8-0";
export var showOverflow = "_y8-1";